/*存放枚举类型*/



/*公示周期*/
export const columns = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10']

/*信息有效期*/
export const validDaysList = ['15', '30', '60', '90', '永久']



/*派活流程*/
export const typeList = [
  { text: '简易流程', id: '2'},
  { text: '招标流程', id: '1'}
]

/*派活对象*/
export const assignWork = ['全部', '个人', '劳务班组', '企业']

export const appraiseList = [
  { name: 1, title: '优' },
  { name: 2, title: '良' },
  { name: 3, title: '中' },
  { name: 4, title: '差' },
]

/*项目tab标签页*/
export const projectTitleList = [
  { name: '1', title: '施工中'},
  { name: '2', title: '已完结'}
]

/*找工作的状态: 个人、班组*/
export const jObBanZhuStatusList = [
  { text: '正在找工作', id: 1},
  { text: '暂不找工作', id: 0}
]
/*找工作的状态: 企业*/
export const jObQiYeStatusList = [
  { text: '正在找合作', id: 1},
  { text: '暂不找合作', id: 0}
]
